import {
  ImageScaleView,
  ImageScaleViewOpts,
  MaskView,
} from '@play-co/timestep-core/ui';
import gsap from 'gsap';

const duration = 3;

export default class TeamCoffeeCup extends ImageScaleView {
  private readonly steams: ImageScaleView[] = [];
  private readonly targetScale: number;
  private time = 0;

  constructor(opts: ImageScaleViewOpts) {
    const width = 166;
    const height = 130;
    const amount = 2;

    super({
      ...opts,
      image: 'assets/ui/match2/team/team_coffee_cup.png',
      width,
      height,
      anchorX: width * 0.5,
      anchorY: height * 0.95,
      offsetX: -width * 0.5,
      offsetY: -height * 0.5,
      scale: 0,
    });

    this.targetScale = opts.scale ?? opts.scaleX ?? opts.scaleY ?? 1;

    const steamViewHeight = 160;
    const steamView = new MaskView({
      superview: this,
      mask: 'assets/ui/match2/team/team_coffee_cup_steam_mask.png',
      width,
      height: steamViewHeight,
      y: 15 - steamViewHeight,
    });

    for (let index = 0; index < amount; index++) {
      this.steams.push(
        new ImageScaleView({
          superview: steamView,
          image: 'assets/ui/match2/team/team_coffee_cup_steam.png',
          width: 47,
          height: 95,
          centerOnOrigin: true,
          x: width * 0.5,
          y: steamViewHeight + 95 * 0.5,
          scaleX: index % 2 === 0 ? 1 : -1,
        }),
      );
    }
  }

  public async show(instant = false) {
    gsap.to(this.style, {
      duration: instant ? Number.EPSILON : 0.6,
      scale: this.targetScale,
      ease: 'back.out(2.5)',
    });
  }

  public tick(dt: number) {
    const offset = 160 + 95 * 0.5;
    const delay = duration / this.steams.length;
    this.time += dt * 0.001;

    this.steams.forEach((steam, index) => {
      const t = this.time + index * delay;
      const a = (t % duration) / duration;
      steam.style.y = offset - a * (steam.style.height * 0.5 + offset);
    });
  }
}
